import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Persons from "./scenes/persons";
import BillAccounts from "./scenes/billaccounts";
import IncomeSources from "./scenes/incomesources";
import PaymentMethods from "./scenes/paymentmethods";
import TimeSheets from "./scenes/timesheets";
import MonthlyIncome from "./scenes/monthlyincome";
import Bills from "./scenes/bills";
import BillsByPaymentStatus from "./scenes/bills/indexByPaymentStatus";
import OutstandingTaxes from "./scenes/outstandingtaxes";
import OutstandingTaxesByPaymentStatus from "./scenes/outstandingtaxes/indexByPaymentStatus";
import UpcomingPayDayCalculator from "./scenes/upcomingpaydaycalculator";
import Budget from "./scenes/budget";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/persons" element={<ProtectedRoute element={<Persons searchTerm={searchTerm} />} />} />
<Route path="/billaccounts" element={<ProtectedRoute element={<BillAccounts searchTerm={searchTerm} />} />} />
<Route path="/incomesources" element={<ProtectedRoute element={<IncomeSources searchTerm={searchTerm} />} />} />
<Route path="/paymentmethods" element={<ProtectedRoute element={<PaymentMethods searchTerm={searchTerm} />} />} />
<Route path="/timesheets" element={<ProtectedRoute element={<TimeSheets searchTerm={searchTerm} />} />} />
<Route path="/timesheets/list" element={<ProtectedRoute element={<TimeSheets searchTerm={searchTerm} />} />} />
<Route path="/monthlyincome" element={<ProtectedRoute element={<MonthlyIncome searchTerm={searchTerm} />} />} />
<Route path="/monthlyincome/list" element={<ProtectedRoute element={<MonthlyIncome searchTerm={searchTerm} />} />} />
<Route path="/bills" element={<ProtectedRoute element={<Bills searchTerm={searchTerm} />} />} />
<Route path="/bills/list" element={<ProtectedRoute element={<Bills searchTerm={searchTerm} />} />} />
<Route path="/bills/paymentstatus" element={<ProtectedRoute element={<BillsByPaymentStatus searchTerm={searchTerm} />} />} />
<Route path="/outstandingtaxes" element={<ProtectedRoute element={<OutstandingTaxes searchTerm={searchTerm} />} />} />
<Route path="/outstandingtaxes/list" element={<ProtectedRoute element={<OutstandingTaxes searchTerm={searchTerm} />} />} />
<Route path="/outstandingtaxes/paymentstatus" element={<ProtectedRoute element={<OutstandingTaxesByPaymentStatus searchTerm={searchTerm} />} />} />
<Route path="/upcomingpaydaycalculator" element={<ProtectedRoute element={<UpcomingPayDayCalculator searchTerm={searchTerm} />} />} />
<Route path="/upcomingpaydaycalculator/list" element={<ProtectedRoute element={<UpcomingPayDayCalculator searchTerm={searchTerm} />} />} />
<Route path="/budget" element={<ProtectedRoute element={<Budget searchTerm={searchTerm} />} />} />
<Route path="/budget/list" element={<ProtectedRoute element={<Budget searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
